import { Button } from "primereact/button";
import React, { useState } from "react";
import "./TooltipLang.css";
import { FormattedMessage } from "react-intl";

function TooltipLang() {
  const [isVisible, setIsVisible] = useState(false);

  const toggleTooltip = () => {
    setIsVisible(!isVisible);
  };

  return (
    <div style={{ position: "relative" }}>
      <Button
        icon="pi pi-question-circle"
        onClick={toggleTooltip}
        className="readysize-tooltip-container"
      />

      {isVisible && (
        <div
          className="tooltip-content"
          style={{
            position: "absolute",
            backgroundColor: "white",
            padding: "15px 20px 15px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            zIndex: 1000,
            right: "0px",
            left: "50px",
            width: "400px",
            height: "auto",
            top: "-20px",
          }}
        >
          <div>
            <p>
              <FormattedMessage
                id="langTooltip"
                defaultMessage="El Lenguaje que elijas va a ser el utilizado por el modal en tu aplicación en sitio."
              />
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default TooltipLang;
